import { type ReactElement, type ReactNode } from 'react'
import { isEmpty, type PermissionListSuccess, type WithPermissionEntityId } from '@terros/common'
import { Page } from '../page'
import { permissionGroupQueryKey } from './util'
import { useDisplayPermissionsRecord } from './usePermissionDisplayFilter'
import { PermissionRadioGroup } from './PermissionRadioGroup'
import { PermissionDisplayWrapper } from './PermissionDisplayWrapper'

export type EntityPermissionsProps = WithPermissionEntityId & {
  permissionList: PermissionListSuccess
  refetch?: () => void
  isFetching?: boolean
  groupQueryKey?: string
  readOnly?: boolean
  stickyToolbar?: boolean
  toolbarActions?: ReactNode
}

export const EntityPermissions = ({
  entityId,
  permissionList,
  refetch,
  isFetching,
  groupQueryKey,
  readOnly,
  stickyToolbar,
  toolbarActions,
}: EntityPermissionsProps): ReactElement => {
  const defaultRecord = useDisplayPermissionsRecord(permissionList.list)

  if (isEmpty(defaultRecord)) return <Page.Hero icon='shield' title='No permissions found' />

  return (
    <PermissionDisplayWrapper
      entityId={entityId}
      defaultRecord={defaultRecord}
      permissionList={permissionList.list}
      groupQueryKey={groupQueryKey ?? permissionGroupQueryKey(entityId)}
      isFetching={isFetching}
      refetch={refetch}
      stickyToolbar={stickyToolbar}
      toolbarActions={toolbarActions}
      render={(type, definition) => {
        const permData = permissionList.list[type]
        if (!permData) return null

        return (
          <PermissionRadioGroup
            entityId={entityId}
            info={permData}
            key={type}
            permDefinition={definition}
            permissionType={type}
            readOnly={readOnly}
          />
        )
      }}
    />
  )
}
